<div class="fw-wrapper">
    <ng-container *im2mLet="stateData$ | async as stateData">
        <mat-icon *ngIf="stateData.icon" [im2mTooltip] content-type="template" [ngClass]="stateData.styleClass">
            {{ stateData.icon }}
            <!-- ToolTip -->
            <im2m-tooltip-content class="tooltip">
                <div class="element" *ngFor="let item of firmwareTooltipItems">
                    <div class="header">
                        {{ 'DEVICES.FIRMWARE.' + (item | uppercase) | transloco }}
                    </div>
                    <div class="content">
                        {{
                            device?.fwUpdateInfo && device?.fwUpdateInfo[item]
                                ? item === 'downloadAllowedTime' || item === 'downloadTime' || item === 'installedTime'
                                    ? (device?.fwUpdateInfo[item] | liebherMarkAsUTC | date : ('DATE_TIME_FORMAT' | transloco))
                                    : device?.fwUpdateInfo[item]
                                : '-'
                        }}

                        <span *ngIf="item === 'downloadAllowedTime' && device?.fwUpdateInfo?.forced"> - {{ 'DEVICES.FIRMWARE.FORCED' | transloco }} </span>
                    </div>
                </div>
            </im2m-tooltip-content>
        </mat-icon>
    </ng-container>

    <ng-container *ngIf="device?.fwUpdateInfo?.installedVersion; else versionElse">
        <div class="fw-version">
            <span class="main-val">
                {{ device?.fwUpdateInfo?.installedVersion }}
            </span>
            <span class="sub-val" *ngIf="device?.fwUpdateInfo?.installedTime">
                {{ device?.fwUpdateInfo?.installedTime | liebherMarkAsUTC | date : ('DATE_TIME_FORMAT' | transloco) }}
            </span>
        </div>
    </ng-container>
    <ng-template #versionElse>-</ng-template>
</div>
